import React from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import MobileAccordion from './MobileAccordion';
import i18n from '../../../src/i18n/translate';
import { WindowHelperWrapper } from "../../util/WindowHelper";

const RESPONSIVE_DATA_BREAKPOINT = 768;

/** renders data either as a MobileAccordion or Table component depending on
 *  the size of the browser window */
export default class ResponsiveDataList extends React.Component {
  static propTypes = {
    /** any table options are passed to MobileAccordion and Table components */
    options: PropTypes.shape({
      /** sets a message to be displayed when the data array is empty */
      noDataText: PropTypes.string
    }),
    /** override the default window object used with WindowHelper */
    windowOverride: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.windowHelper = WindowHelperWrapper(props.windowOverride)
    this.state = {
      isMobile: false
    };
  }

  componentDidMount() {
    this.destroyWindowWatcher = this.windowHelper.watchBreakpoints(
      RESPONSIVE_DATA_BREAKPOINT, this.onBreakpointChange);
  }

  componentWillUnmount() {
    this.destroyWindowWatcher();
  }

  onBreakpointChange = (index) => {
    this.setState({ isMobile: !index });
  }

  /** calling this method to triggers a highlight animation on the row whose
   *  keyField matches the provided value */
  highlightRow = value => {
    if (this.table) {
      this.table.highlightRow(value);
    }
  };

  render() {
    const options = this.props.options || {};
    if (!options.noDataText) {
      options.noDataText = i18n.t("There is no data to display.")
    }

    return (
      <div>
        {this.state.isMobile ?
          <MobileAccordion {...this.props} options={options}/> :
          <Table {...this.props} options={options} ref={table => { this.table = table; }} />}
      </div>
    )

  }
}
